
import { Type } from "src/utils";

/**
 * 表示一个菜单类型。
 * @enum
 * @version 1.0.0
 */
enum MenuType
{
    /**
     * 目录。
     * @member
     */
    catalogue = 0,

    /**
     * 菜单
     * @member
     */
     menu = 1,

    /**
     * 按钮
     * @member
     */
    btn = 2
}

/*
* 定义枚举元数据。
*/
Type.setMetadata(MenuType,
{
    catalogue:
    {
        alias: "目录",
        description: ""
    },
    menu:
    {
        alias: "菜单",
        description: ""
    },
    btn:
    {
        alias: "按钮",
        description: ""
    }
});

export default MenuType;
